import styled from 'styled-components';
import { Stack } from '@appcues/sonar';
import { Link } from 'react-router-dom';

export const LinkWrapper = styled(Link)`
  display: flex;
  text-decoration: none;
  height: 102px;
  border-radius: var(--border-radius-small);
  background-color: var(--color-neutral-0);
  box-shadow: var(--elevation-100);
  transition: color 0.2s, box-shadow 0.2s;

  &:hover {
    box-shadow: var(--elevation-200);
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  background-color: #d6dbe7;
  padding: var(--spacing-small) var(--spacing-regular);
  border-top-left-radius: var(--border-radius-small);
  border-bottom-left-radius: var(--border-radius-small);
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ContentWrapper = styled(Stack).attrs({
  spacing: 'regular',
})`
  flex: 1;
  justify-content: center;
  padding-right: var(--spacing-large);
`;

export const TitleWrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
